export default __webpack_public_path__ + "static/rongyi2-54597e4c131929062f210ba4fcfdd7bc.jpg";